<template>
  <div
    class="object-teaser_otr"
    :class="{ [`otr_${this.typeId}`]: true, [this.curTheme]: true,
      [this.rootClass]: true, [this.taskStatusClass]: true }"
    v-if="showObject"
    @click="onTeaserClick">

    <depo-progress v-if="activeTaskId" :taskId.sync="activeTaskId"/>
    <div
      v-if="dataType === 'object' && objectStatus"
      v-html="objectStatus"
      class="object-status"/>
    <div class="otr_wrap">
      <img v-if="typeId" :src="`/static/grx/icons/objects/${typeId}.svg`" class="otr_icon">

      <h2 v-if="dataType === 'object'" class="otr_title otr_title--object">
        <router-link :to="`/object/${this.dataLocal.ObjectId}`">{{ dataSource.Title }}</router-link>
      </h2>
      <h2 v-else class="otr_title otr_title--task">{{ dataSource.EntityJSON.Title }}</h2>

      <div class="otr_info">
        <el-tooltip
          v-if="typeName"
          :content="typeName"
          placement="top"
          :enterable="false"
          :open-delay="500">
          <div class="otr_info-el otr_type">
            {{ typeName }}
          </div>
        </el-tooltip>

        <el-tooltip
          v-if="dataLocal.ObjectId"
          placement="top"
          :enterable="false"
          :open-delay="500">
          <div slot="content">
            <div class="tooltip-title">Идентификатор объекта:</div>
            <div>{{ dataLocal.ObjectId }}</div>
          </div>
          <div class="otr_info-el otr_type">
            {{ dataLocal.ObjectId }}
          </div>
        </el-tooltip>

        <el-tooltip v-if="authors" placement="top" :enterable="false" :open-delay="openDelay">
          <div slot="content">
            <div class="tooltip-title">Авторы:</div>
            <div v-for="(a, i) in authors" :key="`authors-${i}`">{{ a }}</div>
          </div>
          <div class="otr_info-el otr_authors">
            {{ authors.join(', ') }}
          </div>
        </el-tooltip>

        <el-tooltip placement="bottom" :enterable="false" :open-delay="openDelay">
          <div slot="content">
            <div class="tooltip-title">Организации:</div>
            <div v-for="(o, i) in organizations" :key="`organizations-${i}`">{{ o }}</div>
          </div>
          <div class="otr_info-el otr_organizations">
            {{ organizations.join(', ') }}
          </div>
        </el-tooltip>

        <el-tooltip v-if="objLicenses" placement="bottom"
          :enterable="false" :open-delay="openDelay">
          <div slot="content">
            <div class="tooltip-title">Вид смарт-контракта:</div>
            <div
              v-for="(l, i) in objLicenses"
              class="license-tooltip_lit"
              :key="`license-${i}`">
              <img :src="licenses[l.id].icon" class="lit_icon">
              <div class="lit_title">{{ l.title }}</div>
            </div>
          </div>
          <div class="otr_info-el otr_licenses">
            {{ objLicenses.map(l => l.title).join(', ') }}
          </div>
        </el-tooltip>

        <el-tooltip v-if="createdTime" placement="bottom"
          :enterable="false" :open-delay="openDelay">
          <div slot="content"><span v-html="createdTimePopup"></span></div>
          <div class="otr_info-el otr_created-time">
            {{ createdTime }} (UTC)
          </div>
        </el-tooltip>

        <el-tooltip
          v-if="dataType === 'object' && dataLocal && dataLocal.Rating > 0"
          placement="bottom"
          class="otr_rating"
          :enterable="false"
          :open-delay="openDelay">
          <div slot="content">Рейтинг объекта</div>
          <div class="otr_info-el otr_rating">
            Рейтинг:
            <el-rate
              disabled-void-color="#414141"
              :colors="['#e0446f', '#e0446f', '#e0446f']"
              v-model="dataLocal.Rating"
              disabled />
          </div>
        </el-tooltip>

      </div>

      <div
        v-if="dataType === 'object'"
        class="otr_object-stat_oos">
        <el-tooltip content="Количество просмотров" placement="top"
          v-if="dataLocal && typeof dataLocal.Transient.ViewsNumber !== 'undefined'">
          <div class="oos_el views-number">{{ dataLocal.Transient.ViewsNumber }}</div>
        </el-tooltip>
        <el-tooltip content="Добавлено в избранное" placement="top"
          v-if="dataLocal && typeof dataLocal.Transient.BookmarksNumber !== 'undefined'">
          <div class="oos_el bookmarks-number">{{ dataLocal.Transient.BookmarksNumber }}</div>
        </el-tooltip>
        <el-tooltip content="Количество контрактов" placement="top"
                    v-if="dataLocal && typeof dataLocal.Transient.DealsNumber !== 'undefined'">
          <div class="oos_el deals-number">
            {{ dataLocal.Transient.DealsNumber }}
          </div>
        </el-tooltip>
        <el-tooltip content="Находится у Вас в избранном" placement="top">
          <button class="oos_el oos_bookmarked"
            :class="{ 'bookmarked_visible': dataLocal.IsBookmarked}"></button>
        </el-tooltip>
        <br>

        <el-dropdown
          :hide-on-click="true"
          :trigger="isMobile ? 'click' : 'hover'"
          @command="objectActions">

          <span class="el-dropdown-link"><i class="el-icon-more"></i></span>

          <el-dropdown-menu slot="dropdown" class="el-dropdown--no-links">

            <el-dropdown-item v-if="isAuthenticated && !dataLocal.Transient.IsBookmarked"
              command="addBookmark">Добавить в избранное</el-dropdown-item>

            <el-dropdown-item v-if="isAuthenticated && dataLocal.Transient.IsBookmarked"
              command="deleteBookmark">Убрать из избранного</el-dropdown-item>

            <el-dropdown-item command="viewFullObject">
              Посмотреть описание</el-dropdown-item>

            <!-- <el-dropdown-item command="usageConditions">
              Варианты использования</el-dropdown-item> -->

            <el-dropdown-item command="viewCertificate">
              Сертификат</el-dropdown-item>

          </el-dropdown-menu>

        </el-dropdown>

      </div><!-- /.otr_stat -->

      <div
        v-else
        class="otr_task-status_ots">
        <div v-html="taskStatus" class="ots_status"
          :class="{ [`ots_status--${this.dataSource.Status.toLowerCase()}`]: true }"></div>
        <el-tooltip v-if="taskError.length" placement="bottom"
          :enterable="false" :open-delay="openDelay">
          <div slot="content">
            <div class="tooltip-title">Ошибки:</div>
            <div v-for="(te, i) in taskError" :key="`task-error-${i}`">{{ te }}</div>
          </div>
          <div class="otr_info-el ots_error-label">
            Подробнее
          </div>
        </el-tooltip>
      </div>

      <el-dialog
        v-if="objLicenses"
        title="Варианты использования"
        :visible.sync="usageConditionsVisible">

        <div
          v-for="(l, i) in objLicenses"
          class="licenses_lic"
          :key="`license-dialog-${i}`">
          <img :src="licenses[l.id].icon" class="lic_icon">
          <h2 class="lic_title">{{ l.title }}</h2>
          <p class="lic_desc">{{ l.description }}</p>
        </div>

        <span slot="footer" class="dialog-footer">
          <button class="dialog-close-btn" @click="usageConditionsVisible = false">
            Закрыть</button>
        </span>

      </el-dialog>

    </div><!-- /.otr_wrap -->
  </div><!-- /.object-teaser_otr -->
</template>

<script>
import axios from 'axios';
import DepoProgress from '@/components/DepoProgress';
import licenses from '../data/licenses';
import ObjectMixin from '../mixins/Object';

export default {

  mixins: [ObjectMixin],

  components: { DepoProgress },

  props: {
    dataSource: null,
    dataType: { // 'object' || 'task'
      default: 'object',
    },
  },

  data() {
    return {
      dataLocal: null,
      showObject: true,
      statusClass: '',
      rootClass: '',
      openDelay: 500,
      usageConditionsVisible: false,
      activeTaskId: 0,
      licenses,
    };
  },

  created() {
    if (this.dataType === 'task') {
      this.dataLocal = this.dataSource.EntityJSON;
      this.rootClass = 'otr_task';
      // Show DepoProgress
      if (
        this.$route.query.taskId
        && parseInt(this.$route.query.taskId, 10) === this.dataSource.TaskId
      ) {
        this.activeTaskId = this.dataSource.TaskId;
      }
    } else {
      this.dataLocal = this.dataSource;
      this.rootClass = 'otr_object';
    }
  },

  beforeUpdate() {
    if (this.dataType === 'task') {
      this.dataLocal = this.dataSource.EntityJSON;
      this.rootClass = 'otr_task';
    } else {
      this.dataLocal = this.dataSource;
      this.rootClass = 'otr_object';
    }
  },

  watch: {

    activeTaskId() {
      this.$emit('task-id-changed', this.activeTaskId);
    },

  },

  computed: {

    objectStatus() {
      let status = '';
      if (this.dataLocal && this.dataLocal.Transient.IsBlocked) {
        status = 'Объект заблокирован. ';
        if (this.isAuthenticated
          && this.$route.path === '/user/objects'
          && this.dataLocal.Transient.SignatureRequiredAsAuthor) {
          status += 'Вы указаны в качестве соавтора / правообладателя. Сведения об объекте требуют вашей проверки и подтверждения.<br>Проверьте описание объекта, а также условия предоставления доступа к объекту';
        } else {
          status += this.dataLocal.Transient.Status.StatusTitle;
        }
      }
      return status;
    },

    isMobile() {
      return window.innerWidth <= 830;
    },

    taskStatusClass() {
      let objClass = '';
      if (this.dataType === 'task' && this.dataLocal.Status) {
        objClass = `otr_task-${this.dataLocal.Status.toLowerCase()}`;
      }
      return objClass;
    },

    isAuthenticated() {
      return this.$store.getters['user/isAuthenticated'];
    },

    type() {
      return this.$store.getters['types/getType'](this.dataLocal.Type);
    },

    typeName() {
      return this.type ? this.type.Title : '';
    },

    typeId() {
      return this.type ? this.type.Type : '';
    },

    objLicenses() {
      const objLicenses = [];
      if (this.dataLocal.Licenses && this.dataLocal.Licenses.length && this.licensesAll) {
        this.dataLocal.Licenses.forEach((l) => {
          objLicenses.push({
            id: l,
            title: this.licensesAll.Options[l],
            description: this.licensesAll.OptionsDescriptions[l],
          });
        });
      }
      return objLicenses;
    },

    authors() {
      if (this.dataLocal.Authors && this.dataLocal.Authors.length) {
        const authors = [];
        this.dataLocal.Authors.forEach((a) => {
          authors.push([a.Surname, a.Name, a.Patronymic].join(' '));
        });
        return authors;
      }
      return [];
    },

    organizations() {
      if (this.dataLocal.Organizations && this.dataLocal.Organizations.length) {
        const orgs = [];
        this.dataLocal.Organizations.forEach((org) => {
          orgs.push(org.Organization);
        });
        return orgs;
      }
      return [];
    },

    createdTime() {
      let time = '';
      if (this.dataLocal && this.dataLocal.CreatedTime) {
        const d = new Date(this.dataLocal.CreatedTime * 1000);
        const year = d.getUTCFullYear();

        let month = d.getUTCMonth() + 1;
        if (month < 10) month = `0${month}`;

        let date = d.getUTCDate();
        if (date < 10) date = `0${date}`;

        let hours = d.getUTCHours();
        if (hours < 10) hours = `0${hours}`;

        let minutes = d.getMinutes();
        if (minutes < 10) minutes = `0${minutes}`;

        time = `${date}.${month}.${year} ${hours}:${minutes}`;
      }
      return time;
    },

    createdTimePopup() {
      return `<span class="tooltip-title">Депонирован:</span><br>${this.createdTime}`;
    },

    curTheme() {
      return this.$store.getters['theme/curTheme'];
    },

    taskStatus() {
      let taskStatus = '';
      switch (this.dataSource.Status) {
        case 'FAIL':
          taskStatus = '<i class="el-icon-close"></i> Ошибка'; break;
        case 'SUCCESS':
          taskStatus = '<i class="el-icon-check"></i> Депонирован'; break;
        default:
          taskStatus = '<i class="el-icon-loading"></i> В обработке';
      }
      return taskStatus;
    },

    taskError() {
      const taskError = [];
      if (this.dataSource.Messages && this.dataSource.Status === 'FAIL') {
        this.dataSource.Messages.forEach((m) => {
          taskError.push(m);
        });
      }
      return taskError;
    },

  },

  methods: {

    onTeaserClick() {
      if (this.dataType === 'task' && this.dataSource
        && this.dataSource.Messages === null
      ) {
        this.activeTaskId = this.dataSource.TaskId;
      }
    },

    objectActions(command) {
      this[command]();
    },

    addBookmark() {
      const userId = this.$store.getters['user/getUserId'];
      if (userId) {
        axios.put(`bookmarks/${userId}/${this.dataLocal.ObjectId}`).then(() => {
          this.dataLocal.Transient.IsBookmarked = true;
          this.dataLocal.Transient.BookmarksNumber += 1;
        });
      }
    },

    deleteBookmark() {
      const userId = this.$store.getters['user/getUserId'];
      if (userId) {
        axios.delete(`bookmarks/${userId}/${this.dataLocal.ObjectId}`).then(() => {
          this.dataLocal.Transient.IsBookmarked = false;
          this.dataLocal.Transient.BookmarksNumber -= 1;
        });
      }
    },

    usageConditions() {
      this.usageConditionsVisible = true;
    },

    viewFullObject() {
      this.$router.push({ path: `/object/${this.dataLocal.ObjectId}` });
    },

    viewCertificate() {
      this.$router.push({ path: `/object/${this.dataLocal.ObjectId}/certificate` });
    },

  },

};
</script>

<style lang="scss">
@import "../styles/common/main";
.object-status {
  color: #d74b88;
  font-size: 14px;
  padding-bottom: 20px;
}
.license-tooltip_lit {
  margin: 8px 0;
  @extend .clearfix;
  &:last-of-type {
    margin-bottom: 0;
  }
  .lit_icon {
    float: left;
    width: 40px;
    height: auto;
    margin-right: 10px;
  }
  .lit_title {
    padding-top: 10px;
    line-height: 18px;
  }
}
.object-teaser_otr {
  .views-number:before {
    background: 0 6px no-repeat url(/static/grx/icons/count-views.svg);
  }
  .bookmarks-number:before {
    background: 0 2px no-repeat url(/static/grx/icons/fav-not-set.svg);
  }
  .deals-number:before {
    background: 0 2px no-repeat url(/static/grx/icons/count-deals.svg);
  }
  .otr_rating {
    white-space: nowrap;
    .el-rate {
      float: right;
      margin-left: 6px;
      .el-rate__icon {
        margin-right: 2px;
      }
    }
  }
  .otr_task-status_ots {
    position: absolute;
    top: 0;
    right: 0;
    text-align: right;
    .ots_status {
      font-size: 16px;
      color: #aaa;
      i {
        display: inline-block;
        margin-right: 3px;
        font-size: 22px;
        color: #fff;
        vertical-align: top;
      }
      &.ots_status--fail {
        color: #b82121;
      }
    }
    .ots_error-label {
      font-size: 12px;
      cursor: help;
      color: #fff;
      border-bottom: 1px dashed #fff;
      display: inline-block;
    }
  }
  .otr_rating {
    white-space: nowrap;
  }
}
.object-short {
  margin: 20px 0;
  padding: 30px 30px 25px;
  border-radius: 10px;
  min-height: 55px;
  background-color: #1a1a1a;
  color: #fff;
}
.wrap {
  position: relative;
  padding-left: 70px;
  padding-right: 220px;
}
.icon {
  position: absolute;
  left: -2px;
  top: 0;
  width: auto;
  height: 50px;
}
.title {
  font-size: 17px;
  line-height: 20px;
  margin: 0 0 10px;
  padding: 0;
  font-weight: normal;
  cursor: pointer;
}
.info {
  .info-el {
    font-size: 14px;
    display: inline-block;
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    max-width: 140px;
    cursor: help;
    color: #aaa;
  }
}
.stat {
  position: absolute;
  top: 0;
  right: 0;
  height: 40px;
  text-align: right;
  .stat-el {
    display: inline-block;
    margin-left: 15px;
    font-size: 12px;
    padding: 5px 0 0 30px;
    height: 30px;
    vertical-align: top;
    position: relative;
    background: transparent;
    border: none;
    color: #aaa;
    &:before {
      content: '';
      width: 23px;
      height: 23px;
      float: left;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .views:before {
    background: 0 0 no-repeat url(/static/grx/icons/count-views.svg);
  }
  .comments:before {
    background: 0 0 no-repeat url(/static/grx/icons/comment.svg);
  }
  .reviews:before {
    background: 0 0 no-repeat url(/static/grx/icons/review.svg);
  }
  .bookmarked {
    padding-left: 18px;
    display: none;
    &:before {
      background: 0 0 no-repeat url(/static/grx/icons/star.svg);
    }
    &.bookmarked_visible {
      display: inline-block;
    }
  }
  .el-dropdown-link {
    display: block;
    font-size: 20px;
    margin-top: 5px;
    width: 30px;
    height: 20px;
    outline: none !important;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ObjectTeaser.vue